"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("./Style.css");

require("@identitybuilding/idb-react-ui-elements");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));

var _axios = _interopRequireDefault(require("axios"));

var _leaflet = require("leaflet");

var _MapMarker = _interopRequireDefault(require("@identitybuilding/idb-react-map/dist/MapMarker"));

var _logo_placeholder = _interopRequireDefault(require("./images/logo_placeholder.png"));

var _BusinessCard = _interopRequireDefault(require("./BusinessCard"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _function = require("./utils/function");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Relations = function Relations(props) {
  var env = (0, _function.getEnvEndpoints)();

  var translate = function translate(e) {
    return (0, _idbReactTranslations["default"])(e, props.lang);
  };

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      relations = _useState2[0],
      setRelations = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      relationTypes = _useState4[0],
      setRelationTypes = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      zoomed = _useState6[0],
      setZoomed = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      loaded = _useState8[0],
      setLoaded = _useState8[1];

  var _useState9 = (0, _react.useState)(''),
      _useState10 = _slicedToArray(_useState9, 2),
      bounds = _useState10[0],
      setBounds = _useState10[1];

  var _useState11 = (0, _react.useState)([]),
      _useState12 = _slicedToArray(_useState11, 2),
      addresses = _useState12[0],
      setAddresses = _useState12[1];

  var _useState13 = (0, _react.useState)({}),
      _useState14 = _slicedToArray(_useState13, 2),
      mapSettings = _useState14[0],
      setMapSettings = _useState14[1]; // getting data only one time, that why we use 2 different useEffect


  (0, _react.useEffect)(function () {
    var bounds = (0, _leaflet.latLngBounds)(); // seemed to work without having to pass init arg

    if (addresses && addresses.length > 0) {
      addresses.forEach(function (coords) {
        // this.state.addresses.forEach(coords => {
        bounds.extend([coords.data.address.lat, coords.data.address["long"]]);
      });
      setBounds(bounds);
    }

    if (props.relations.length === 0) {
      getData();
    } else {
      setAddresses(props.relations);
    }
  }, []);

  var getData = function getData() {
    var as_model = require('./models/RelationModel')["default"];

    var as_to_model = require('./models/ToRelationModel')["default"];

    if (props.relation_type === 0) {
      _axios["default"].get("https://search-osn-management-hkfarflgp5aj2vbhfzvmyycuuy.eu-central-1.es.amazonaws.com/relations/_search?q=establishment_number:".concat(props.id), {
        auth: {
          username: "osn-admin",
          password: "O15s19n14!+"
        }
      }).then(function (res) {
        if (res.data.hits.hits.length > 0) {
          var results = [];
          var newBounds = [];
          var relation_types = [];
          res.data.hits.hits.forEach(function (hit) {
            hit._source.relations.forEach(function (relation) {
              _axios["default"].get("https://search-osn-management-hkfarflgp5aj2vbhfzvmyycuuy.eu-central-1.es.amazonaws.com/establishments/_search?q=number:".concat(relation.number), {
                auth: {
                  username: "osn-admin",
                  password: "O15s19n14!+"
                }
              }).then(function (response) {
                var resp = response.data.hits.hits[0]._source;
                var data = as_model(resp, relation, props.lang);
                results.push(data.object);

                if (relation_types.filter(function (e) {
                  return e.title === data.relation_types[0].title;
                }).length === 0) {
                  relation_types.push({
                    title: data.relation_types[0].title,
                    color: data.relation_types[0].color
                  });
                }

                newBounds.push(data.newBounds);
              });
            });
          });
          setTimeout(function () {
            setAddresses(results);
            setBounds(newBounds);
            setRelationTypes(relation_types);
          }, 1000);
          setLoaded(true);
        }
      });
    } else {
      _axios["default"].get("".concat(env.REACT_APP_BASE_MEDIA_URL, "/core/api/business/").concat(props.id, "/relations/?lang=").concat(props.lang)) // axios.get(`http://localhost:8000/core/api/business/${props.id}/relations/?lang=${props.lang}`)
      .then(function (res) {
        if (res.data.to_relation.length > 0) {
          var data = as_to_model(res.data, props.lang);
          setRelationTypes(data.relation_types);
          setAddresses(data.result);
          setBounds(data.newBounds);
          setLoaded(!loaded);
        }
      });
    }
  };

  var settings = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    infinite: true,
    initialSlide: 0,
    lazyload: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    variableWidth: true,
    pauseOnhover: true,
    swipe: false
  };
  return /*#__PURE__*/_react["default"].createElement("section", {
    id: "relations",
    className: "temp-".concat(props.relation_type)
  }, props.relation_type === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "iconContainer"
  }, relationTypes.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    id: "legende"
  }, relationTypes.map(function (res, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: "legende_item"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        backgroundColor: res.color
      }
    }), " ", res.title);
  })), bounds && loaded && addresses.length > 0 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MapMarker["default"], {
    bounds: bounds,
    addresses: addresses.reverse(),
    scrollTo: function scrollTo(e) {
      return console.log(e);
    },
    getMap: function getMap(e) {
      return console.log(e);
    } // zoomed={zoomed}
    // setZoomed={(e) => setZoomed(e)}
    ,
    zoomLvl: 16 // page='brands'

  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: "card_wrapper"
  }, addresses.map(function (res, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "card",
      id: res.data.id,
      key: index // onClick={() => handleClick(res.data.id, res.data.address)}

    }, res.data.logos.length > 0 && res.data.logos.length > 1 ? /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], settings, res.data.logos.map(function (logo, index) {
      return /*#__PURE__*/_react["default"].createElement("figure", {
        key: index
      }, /*#__PURE__*/_react["default"].createElement("img", {
        src: logo.logo
      }));
    })) : res.data.logos.length > 0 ? /*#__PURE__*/_react["default"].createElement("figure", null, /*#__PURE__*/_react["default"].createElement("img", {
      src: res.data.logos[0].logo
    })) : /*#__PURE__*/_react["default"].createElement("figure", null, /*#__PURE__*/_react["default"].createElement("img", {
      src: _logo_placeholder["default"]
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cardContent"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "res_name"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, res.data.establishment_name ? res.data.establishment_name : res.data.enterprise_name)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cardRow"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "card_address",
      title: "".concat(res.data.address.line_1)
    }, res.data.address.line_1), /*#__PURE__*/_react["default"].createElement("span", {
      className: "card_address",
      title: "".concat(res.data.address.line_2)
    }, res.data.address.line_2)))), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cardLinks"
    }, /*#__PURE__*/_react["default"].createElement("a", {
      target: "_blank",
      href: "https://www.ondernemersnetwerk.be/business/".concat(res.data.vat, "/").concat(res.data.establishment_name, "/contact")
    }, " ", /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "ArrowDoubleRight"
    }))));
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    id: "loading"
  }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Loading",
    animated: true
  }))) : addresses.map(function (res, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "cardwrapper",
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_BusinessCard["default"], {
      entity: res.data.id,
      index: index,
      id: res.id
    }));
  }));
};

var _default = Relations;
exports["default"] = _default;